/* Magnifixcarp · Accueil v4
   - Choix du département (listes, « Me localiser »), gardé dans le navigateur (clé mfxMeteoDept, partagée avec la page Météo)
   - Sans la section « Au bord de l'eau » sur la page : le choix du département dans la bannière ouvre le guide du département
     (données des guides : <script data-h-data> de la bannière)
   - Section « Au bord de l'eau » (si elle est présente) : vue France / vue département
   - Météo et lune : assets/mfx-home-meteo.js (window.MfxHMeteo) ; données fixes : assets/mfx-home-data.js (window.MfxHData)
   - Filtres du mur des prises */
(function () {
  'use strict';
  if (window.mfxHome) return;
  window.mfxHome = true;

  var KEY = 'mfxMeteoDept';
  var D = window.MfxHData || {};
  var PREF = D.PREF || '';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function store(k, v) { try { if (v) localStorage.setItem(k, v); else localStorage.removeItem(k); } catch (e) {} }
  function load(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }

  /* ---------- Données ---------- */
  var DEPTS = PREF.split(';').map(function (s) { var p = s.split('|'); return { c: p[0], n: p[1], v: p[2], lat: +p[3], lon: +p[4] }; });
  var BY = {}; DEPTS.forEach(function (d) { BY[d.c] = d; });
  var DATA = { guides: '', base: '/blogs/peche-carpe', actus: [], enduros: [], partners: [] };
  function readData() {
    var el = document.querySelector('[data-h-bord] [data-h-data]') || document.querySelector('[data-h-data]');
    if (!el) return;
    try { DATA = JSON.parse(el.textContent); } catch (e) {}
    (DATA.guides || '').split(',').forEach(function (g) {
      var p = g.split('|'), m = /\(([0-9AB]{2})\)\s*$/.exec(p[1] || '');
      if (m && BY[m[1]]) BY[m[1]].h = p[0];
    });
  }

  /* ---------- Listes de départements ---------- */
  function fillSelects() {
    var opts = DEPTS.slice().sort(function (a, b) { return a.n.localeCompare(b.n, 'fr'); })
      .map(function (d) { return '<option value="' + d.c + '">' + esc(d.n) + ' (' + d.c + ')</option>'; }).join('');
    document.querySelectorAll('[data-h-dep-select]').forEach(function (s) {
      if (s.dataset.hFilled) return;
      s.dataset.hFilled = '1';
      s.insertAdjacentHTML('beforeend', opts);
    });
  }
  function syncSelects(c) { document.querySelectorAll('[data-h-dep-select]').forEach(function (s) { s.value = c || ''; }); }

  /* ---------- État ---------- */
  var current = '';
  function setDept(c, scroll) {
    if (c && !BY[c]) c = '';
    current = c;
    store(KEY, c);
    syncSelects(c);
    render();
    if (scroll) {
      var t = document.getElementById('au-bord-de-l-eau');
      if (t) t.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
  }
  /* Sans la section « Au bord de l'eau » : le département choisi ouvre son guide. Renvoie true si la page change. */
  function openGuide(c) {
    var d = BY[c];
    if (document.querySelector('[data-h-bord]') || !d || !d.h) return false;
    store(KEY, c);
    window.location.href = DATA.base + '/' + d.h;
    return true;
  }

  function render() {
    var bord = document.querySelector('[data-h-bord]');
    var d = BY[current];
    if (bord) {
      bord.querySelectorAll('[data-h-when]').forEach(function (el) { el.hidden = el.getAttribute('data-h-when') !== (d ? 'dep' : 'france'); });
      var title = bord.querySelector('[data-h-bord-title]');
      if (title) title.textContent = d ? d.n + ' (' + d.c + ')' : 'Toute la France';
      var lab = bord.querySelector('[data-h-pick-label]');
      if (lab) lab.textContent = d ? 'Changer de département' : 'Choisis ton département';
      if (d) renderDept(bord, d);
    }
    var tab = document.querySelector('[data-h-mur-tab="dep"]');
    if (tab) {
      tab.hidden = !d;
      if (!d && tab.getAttribute('aria-pressed') === 'true') murFilter('all');
    }
  }

  /* ---------- Vue département ---------- */
  function renderDept(bord, d) {
    var guide = bord.querySelector('[data-h-guide]');
    if (guide && d.h) guide.href = DATA.base + '/' + d.h;
    var gt = bord.querySelector('[data-h-guide-title]');
    if (gt) gt.textContent = d.n + ' : où pêcher la carpe';

    var ul = bord.querySelector('[data-h-evs-dep]');
    if (ul) {
      var list = (DATA.enduros || []).slice(0, 5), mine = (DATA.enduros || []).filter(function (e) { return e.c === d.c; })[0];
      if (mine && list.indexOf(mine) === -1) list = list.slice(0, 4).concat([mine]);
      ul.innerHTML = list.length ? list.map(function (e) {
        var m = e.c === d.c;
        return '<li' + (m ? ' class="is-mine"' : '') + '><a href="' + esc(e.u) + '"><span class="mfx-h-evs__date">' + esc(e.w) + '</span><span><b>' + esc(e.n) + '</b>' +
          (e.dn ? '<small>' + esc(e.dn) + ' (' + esc(e.c) + ')</small>' : '') + (m ? '<span class="mfx-h-evs__mine">dans ton département</span>' : '') + '</span></a></li>';
      }).join('') : '<li class="mfx-h-muted">Les prochaines dates arrivent bientôt.</li>';
    }

    var news = bord.querySelector('[data-h-news-dep]');
    if (news) {
      var mineN = (DATA.actus || []).filter(function (a) { return a.c === d.c; }).slice(0, 3);
      news.innerHTML = mineN.length ? mineN.map(newsItem).join('') :
        '<li class="mfx-h-muted">Rien de neuf ces derniers temps pour ce département : les règles du guide sont à jour.</li>';
    }

    var cards = bord.querySelectorAll('[data-h-pe]'), found = false;
    cards.forEach(function (c) {
      var ok = !found && (c.getAttribute('data-h-pe') || '').split(',').indexOf(d.c) !== -1;
      c.hidden = !ok; if (ok) found = true;
    });
    var inv = bord.querySelector('[data-h-pe-invite]');
    if (inv) {
      inv.hidden = found;
      var span = inv.querySelector('[data-h-pe-dep]');
      if (span) span.textContent = ' (' + d.n + ')';
    }

    if (window.MfxHMeteo) window.MfxHMeteo.meteoDept(bord, d);
  }
  function newsItem(a) {
    return '<li><a href="' + esc(a.u) + '"><small>' + esc(a.d) + (a.dn ? ' · ' + esc(a.dn) + ' (' + esc(a.c) + ')' : '') + '</small><b>' + esc(a.t) + '</b></a></li>';
  }

  /* ---------- Me localiser : préfecture la plus proche (seul le numéro du département est gardé) ---------- */
  function locate(btn) {
    var scope = (btn && btn.closest('[data-h-locate-scope]')) || document;
    var msg = scope.querySelector('[data-h-locate-msg]') || document.querySelector('[data-h-locate-msg]');
    function say(t) { if (msg) msg.textContent = t; }
    if (!navigator.geolocation) { say('Ton navigateur ne permet pas la localisation : choisis ton département dans la liste.'); return; }
    say('Localisation en cours…');
    navigator.geolocation.getCurrentPosition(function (pos) {
      var la = pos.coords.latitude, lo = pos.coords.longitude, best = null, bd = Infinity;
      DEPTS.forEach(function (d) {
        var dx = (d.lon - lo) * Math.cos(la * Math.PI / 180), dy = d.lat - la, dist = dx * dx + dy * dy;
        if (dist < bd) { bd = dist; best = d; }
      });
      if (!best || bd > 9) { say('Tu sembles hors de France : choisis ton département dans la liste.'); return; }
      if (openGuide(best.c)) { say('Direction le guide : ' + best.n + '…'); return; }
      say('');
      setDept(best.c, true);
    }, function () { say('Localisation refusée : choisis ton département dans la liste.'); }, { maximumAge: 600000, timeout: 10000, enableHighAccuracy: false });
  }

  /* ---------- Mur des prises : filtres ---------- */
  function murFilter(mode) {
    var grid = document.querySelector('[data-h-mur-grid]');
    if (!grid) return;
    document.querySelectorAll('[data-h-mur-tab]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-h-mur-tab') === mode); });
    var items = Array.prototype.slice.call(grid.children);
    items.forEach(function (it) { it.hidden = mode === 'dep' && it.getAttribute('data-dept') !== current; });
    if (mode === 'top') items.sort(function (a, b) { return (+b.getAttribute('data-votes')) - (+a.getAttribute('data-votes')); });
    else items.sort(function (a, b) { return (b.classList.contains('mfx-h-prise--star') ? 1 : 0) - (a.classList.contains('mfx-h-prise--star') ? 1 : 0); });
    items.forEach(function (it) { grid.appendChild(it); });
  }

  /* ---------- Démarrage ---------- */
  function init() {
    readData();
    fillSelects();
    if (window.MfxHMeteo) window.MfxHMeteo.renderLune();
    if (window.MfxHMeteo) window.MfxHMeteo.initWeekend();
    var saved = load(KEY);
    setDept(BY[saved] ? saved : '', false);
  }
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-h-dep-select]');
    if (!s || s.closest('[data-h-hero-form]')) return;
    setDept(s.value, false);
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-h-hero-form]');
    if (!f) return;
    e.preventDefault();
    var s = f.querySelector('[data-h-dep-select]');
    if (s && s.value) { if (!openGuide(s.value)) setDept(s.value, true); }
    else if (s) s.focus();
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-h-locate],[data-h-clear],[data-h-mur-tab]');
    if (!b) return;
    if (b.hasAttribute('data-h-locate')) locate(b);
    else if (b.hasAttribute('data-h-clear')) setDept('', false);
    else murFilter(b.getAttribute('data-h-mur-tab'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();